(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = setupAreaControl

function setupAreaControl ($el) {
  var control = $el
    , textarea = control.find('.js-textarea')
    , label = control.find('.js-label')
    , blurTimeout = null

  textarea.data('api', { updateText: updateText })

  label.on('click', function (e) { e.preventDefault() })

  if (textarea.val() === '') {
    control.addClass('ec-textarea-control--is-empty')
  } else {
    control.removeClass('ec-textarea-control--is-empty')
  }

  textarea.on('blur', function () {
    removeTextareaIfEmptyOrScrollUp()
  })

  textarea.on('focus', function () {
    textarea.off('scroll', hideLabel)
  })

  if (control.hasClass('ec-textarea-control--is-empty')) {
    control.on('click', addTextarea)
  } else {
    textarea.on('scroll', hideLabel)
  }

  function updateText (text) {
    textarea.val(text)
    if (text !== '') control.removeClass('ec-textarea-control--is-empty')

    if (control.hasClass('ec-textarea-control--is-empty')) {
      control.on('click', addTextarea)
    } else {
      textarea.on('scroll', hideLabel)
    }
  }

  function addTextarea () {
    control.removeClass('ec-textarea-control--is-empty')
    textarea.focus()
  }

  function removeTextareaIfEmptyOrScrollUp () {
    if (textarea.val() === '') {
      clearTimeout(blurTimeout)
      blurTimeout = setTimeout(function () {
        control.addClass('ec-textarea-control--is-empty')
        control.off('click', addTextarea).on('click', addTextarea)
        control.removeClass('is-scrolling')
      }, 150)
    } else {
      textarea.scrollTop(0)
      textarea.on('scroll', hideLabel)
    }
  }

  function hideLabel () {
    if (textarea.scrollTop() > 10) {
      control.addClass('is-scrolling')
    } else {
      control.removeClass('is-scrolling')
    }
  }
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/textarea-control.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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